import { render } from "./BrandDiePresse.vue?vue&type=template&id=1968f975"
import script from "./BrandDiePresse.vue?vue&type=script&lang=ts"
export * from "./BrandDiePresse.vue?vue&type=script&lang=ts"

import "./BrandDiePresse.vue?vue&type=style&index=0&id=1968f975&lang=scss"
script.render = render

export default script